import { AcademyCourse } from '../../models/academy-course.model';

export const didacticsCourse: AcademyCourse = {
  slug: 'how-tutoring-works',
  trainingModuleId: 'didactics',
  isGermanOnly: true,
  titleKey: 'texts.Tutor_Academy_Course_Didactics_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_Didactics_Description',
  isMandatory: false,
  hasSearchBoost: true,
  lessons: [
    {
      id: 'nachhilfe-ist-nicht-schule',
      titleKey: 'texts.Tutor_Academy_Didactics_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_Didactics_L1_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L1_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L1_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L1_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L1_Paragraph4' }
      ]
    },
    {
      id: 'die-luecke-finden',
      titleKey: 'texts.Tutor_Academy_Didactics_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_Didactics_L2_Subtitle',
      headingKey: 'texts.Tutor_Academy_Didactics_L2_Heading',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_Didactics_L2_Download_Url',
      actionLabelKey: 'texts.Tutor_Academy_Didactics_L2_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph5' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L2_Paragraph6' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Didactics_L2_Item1',
            'texts.Tutor_Academy_Didactics_L2_Item2'
          ]
        }
      ]
    },
    {
      id: 'gezielt-erklaeren',
      titleKey: 'texts.Tutor_Academy_Didactics_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_Didactics_L3_Subtitle',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_Didactics_L3_Download_Url',
      actionLabelKey: 'texts.Tutor_Academy_Didactics_L3_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L3_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L3_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L3_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L3_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L3_Paragraph5' }
      ]
    },
    {
      id: 'rahmenlehrplan',
      titleKey: 'texts.Tutor_Academy_Didactics_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_Didactics_L4_Subtitle',
      type: 'text',
      actionUrlKey: 'texts.Tutor_Academy_Didactics_L4_Download_Url',
      actionLabelKey: 'texts.Tutor_Academy_Didactics_L4_Action',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph5' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph6' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Didactics_L4_Paragraph7' }
      ]
    }
  ],
  quiz: [
    {
      id: 'diagnose',
      questionKey: 'texts.Tutor_Academy_Didactics_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'kapitel-neu', textKey: 'texts.Tutor_Academy_Didactics_Q1_Answer1' },
        { id: 'vormachen-lassen', textKey: 'texts.Tutor_Academy_Didactics_Q1_Answer2' },
        { id: 'zusatzaufgaben', textKey: 'texts.Tutor_Academy_Didactics_Q1_Answer3' },
        { id: 'eltern-fragen', textKey: 'texts.Tutor_Academy_Didactics_Q1_Answer4' }
      ],
      correctAnswerIds: ['vormachen-lassen'],
      explanationKey: 'texts.Tutor_Academy_Didactics_Q1_Explanation'
    },
    {
      id: 'luecke-davor',
      questionKey: 'texts.Tutor_Academy_Didactics_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'faktorisieren', textKey: 'texts.Tutor_Academy_Didactics_Q2_Answer1' },
        { id: 'weitermachen', textKey: 'texts.Tutor_Academy_Didactics_Q2_Answer2' },
        { id: 'andere-methode', textKey: 'texts.Tutor_Academy_Didactics_Q2_Answer3' },
        { id: 'kapitel-lesen', textKey: 'texts.Tutor_Academy_Didactics_Q2_Answer4' }
      ],
      correctAnswerIds: ['faktorisieren'],
      explanationKey: 'texts.Tutor_Academy_Didactics_Q2_Explanation'
    },
    {
      id: 'rahmenlehrplan',
      questionKey: 'texts.Tutor_Academy_Didactics_Q3_Question',
      isMultiSelect: false,
      answers: [
        { id: 'jahresprogramm', textKey: 'texts.Tutor_Academy_Didactics_Q3_Answer1' },
        { id: 'kompetenzen-sehen', textKey: 'texts.Tutor_Academy_Didactics_Q3_Answer2' },
        { id: 'note-bestimmen', textKey: 'texts.Tutor_Academy_Didactics_Q3_Answer3' },
        { id: 'nur-lehrkraefte', textKey: 'texts.Tutor_Academy_Didactics_Q3_Answer4' }
      ],
      correctAnswerIds: ['kompetenzen-sehen'],
      explanationKey: 'texts.Tutor_Academy_Didactics_Q3_Explanation'
    }
  ]
};
